import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import Button from '@material-ui/core/Button';
//import SearchIcon from '@material-ui/icons/Search';
import SearchIcon from '@material-ui/icons/PlayArrow';

import { IconButton } from '@material-ui/core';
import FMPText from '../pureForm/FMPText';
import FormComponent from '../FormComponent';

//- ui
import FMPHeadline from '../../components/ui/FMPHeadline';
//import FMPText from '../../components/pureForm/FMPText';

import { getSharedStyles } from '../../themes';

const styles = (theme) => {
	return {
		...getSharedStyles(theme),
		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		savedSearchHelp: {
			padding: 5,
			color: '#444',
			backgroundColor: '#f7f7f7',
			border: '1px solid #eee',
			fontWeight: 200,
			fontSize: '90%',
		},
		saveNewSearchSection: {
			//borderTop : '1px solid #d7d7d7',
			marginTop: 20,
			paddingTop: 10,
		},
		noSavedSearches: {
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		savedSearchContainer: {
			marginTop: 5,
			paddingTop: 5,
			borderBottom: '1px solid #d7d7d7',
			marginBottom: 5,
			paddingBottom: 2,
			display: 'flex',
			justifyContent: 'space-between',
		},
		addedOn: {
			fontSize: '85%',
			fontWeight: 200,
			color: '#666',
			paddingTop: 3,
		},
	};
};

class SavedSearches extends FormComponent {
	constructor(props) {
		super(props);

		const searchContext = props.searchContext;
		let savedSearches = [];
		if (localStorage.getItem(searchContext)) {
			try {
				savedSearches = JSON.parse(localStorage.getItem(searchContext));
			} catch (e) {
				console.error('problems fetching saved searches from local storage', e);
			}
		}
		this.state = {
			savedSearches,
		};
	}

	render() {
		const { classes } = this.props;
		const { savedSearches } = this.state;
		return (
			<>
				<FMPHeadline label="My Saved Searches" />
				<Paper className={classes.paper}>
					<div className={classes.savedSearchHelp}>
						<strong>How to use:</strong> First set the values for all the search fields, then pick a
						name, and hit add. This saved search will be available on future visits.
					</div>
					{_.isEmpty(savedSearches) && (
						<div className={classes.noSavedSearches}>No saved searches</div>
					)}

					{savedSearches.map((savedSearch, index) => {
						const { name, dateCreated } = savedSearch;
						return (
							<div className={classes.savedSearchContainer} key={name}>
								<div>
									<div>
										<strong>Name:</strong> {name}
									</div>
									<div className={classes.addedOn}>
										Date Created: {moment(dateCreated).format('MMM D, YYYY')}
									</div>
								</div>
								<div>
									<IconButton
										color="primary"
										onClick={() => {
											this.submitSavedSearch(index);
										}}
									>
										<SearchIcon />
									</IconButton>

									<IconButton
										onClick={() => {
											this.removeSavedSearch(index);
										}}
									>
										<DeleteIcon />
									</IconButton>
								</div>
							</div>
						);
					})}

					<div className={classes.saveNewSearchSection}>
						<FMPText {...this.setForm('savedName', 'Name of saved search', false)} />
						<Button
							variant={'outlined'}
							color="primary"
							style={{ marginTop: 5 }}
							onClick={() => {
								this.saveSearch();
							}}
						>
							Save Search
						</Button>
					</div>
				</Paper>
			</>
		);
	}

	submitSavedSearch(index) {
		const { savedSearches } = this.state;
		const savedSearch = savedSearches[index];
		if (!savedSearch) {
			console.error('Saved search empty', savedSearches);
			return;
		}
		const { savedState } = savedSearch;
		this.props.onSubmitSearch({ savedState });
	}

	removeSavedSearch(index) {
		const { savedSearches } = this.state;
		const newSavedSearches = savedSearches.slice();
		newSavedSearches.splice(index, 1);
		this.setState({ savedSearches: newSavedSearches }, () => {
			localStorage.setItem(this.props.searchContext, JSON.stringify(newSavedSearches));
		});
	}

	saveSearch() {
		const savedState = this.props.getStateToSave();
		// returned an error
		if (!savedState) {
			return;
		}

		const { savedSearches, savedName } = this.state;

		const formFieldError = {};
		if (!savedName) {
			formFieldError.savedName = `Do you like chaos?! If you don't name your search then you get chaos.`;
			this.setState({ formFieldError });
		}
		const newSavedSearches = savedSearches.concat({
			name: savedName,
			dateCreated: moment().format('YYYY-MM-DD HH:mm'),
			savedState,
		});

		this.setState({ savedSearches: newSavedSearches }, () => {
			localStorage.setItem(this.props.searchContext, JSON.stringify(newSavedSearches));
		});
	}
}

SavedSearches.propTypes = {
	searchContext: PropTypes.string.isRequired,
	onSubmitSearch: PropTypes.func.isRequired,
	getStateToSave: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles, { withTheme: true })])(SavedSearches);
